module.exports = "::ng-deep .bs-rating-star {\n  font-size: 2rem !important;\n}"